import { ReactNode } from 'react';

import { IconButtonVariant } from '@/components/generic/IconButton/icon-button-config';

export enum ButtonVariant {
  PRIMARY = 0,
  SECONDARY = 1,
  TERTIARY = 2,
  QUATERNARY = 3,
  QUINARY = 4,
  SENARY = 5
}

export const DEFAULT_BUTTON_STYLES = [
  'flex',
  'flex-row',
  'items-center',
  'transition-all',
  'duration-300'
].join(' ');

export const BUTTON_STYLES = {
  [ButtonVariant.PRIMARY]:
    'bg-primary-blue rounded-[10px] h-10 px-6 justify-center hover:shadow-primary text-base font-bold text-primary-white',
  [ButtonVariant.SECONDARY]:
    'h-10 px-4 text-primary-blue justify-center hover:shadow-primary rounded-[10px] text-primary-blue border border-primary-blue text-sm leading-normal font-bold',
  [ButtonVariant.TERTIARY]: 'justify-center',
  [ButtonVariant.QUATERNARY]:
    'bg-accent-light-blue rounded-[10px] h-10 px-6 justify-center text-primary-blue hover:shadow-primary font-bold',
  [ButtonVariant.QUINARY]:
    'bg-accent-light-blue rounded-[16px] h-14 px-6 justify-center text-primary-blue border-2 border-solid border-secondary-pale-blue-gray hover:shadow-primary font-bold',
  [ButtonVariant.SENARY]:
    'inline-block rounded-full border border-blue-200 px-4 py-1 text-sm font-medium text-gray-800 cursor-auto'
};

export const DISABLED_BUTTON_STYLE = [
  'cursor-auto',
  '!hover:shadow-none',
  '!shadow-none',
  'border-secondary-steel-blue',
  'opacity-60'
].join(' ');

export enum BUTTON_TYPE {
  BUTTON = 'button',
  ICON_BUTTON = 'iconButton',
  LINK = 'link'
}

export type ButtonConfig = {
  type: BUTTON_TYPE;
  handleOnClick?: () => void;
  label?: string;
  variant?: ButtonVariant | IconButtonVariant;
  isDisabled?: boolean;
  className?: string;
  permissions?: string[];
  icon?: ReactNode;
  isHidden?: boolean;
  path?: string;
};
